import React, { useState, useEffect, useRef } from "react";
import './AdvertisementSlider.css';
import { useAppSelector } from "../../store/hooks";

const AdvertisementSlider: React.FC<{ images: {img: string, link?: string}[]; interval?: number }> = ({ images, interval = 3000 }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [copies, setCopies] = useState(images.length); // Initial guess
    const screenwidth = useAppSelector((s) => s.display.displayWidth);
    const [totalImagesWidth, setTotalImagesWidth] = useState(0);

    // Dynamically determine how many copies of images are needed to fill the width
    useEffect(() => {
        if (containerRef.current  && images.length > 0 && totalImagesWidth > 0) {
            const containerWidth = screenwidth * 2; // 2x screen width
            const imagesWidth = totalImagesWidth || 1; // Avoid division by zero
            const neededCopies = Math.max(1, Math.ceil(containerWidth / imagesWidth) + 1); // Ensure at least 1 copy
            setCopies(neededCopies * images.length);
        }
    }, [images.length, screenwidth, totalImagesWidth]);

    useEffect(() => {
        calculateTotalImagesWidth(images.map((itm) => itm.img));
    }, [images.length])

    const calculateTotalImagesWidth = async (imageUrls: string[]) => {
        let totalWidth = 0;
        for (let img of imageUrls) {
            const res = await getImageWidth(img);
            totalWidth += res;
        }
        setTotalImagesWidth(totalWidth);
    }

    const getImageWidth = (src: string): Promise<number> => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.style.height = "70px";
            img.src = src;
    
            // Ensure the image is fully loaded before measuring
            img.onload = () => {
                const aspectRatio = img.naturalWidth / img.naturalHeight;
                const newWidth = 70 * aspectRatio;
                resolve(Math.round(newWidth * 100) / 100);
            }; 
        });
    };

    return (
        <div className="w-full overflow-hidden bg-gray-100">
            <div
                ref={containerRef}
                className="inline-flex animate-scroll"
                style={{ animationDuration: "50s" }} // Control scroll speed test
            >
                {Array.from({ length: Math.max(copies, images.length) }).map((_, idx) => (
                    <img key={idx} src={images[idx % images.length].img} alt={`Ad ${idx}`} className="h-[70px] max-w-none w-fit cursor-pointer" 
                    onClick={() => {
                        if (images[idx % images.length].link) {
                            window.open(images[idx % images.length].link, '_blank')
                        }
                    }} />
                ))}
                {/* add second time the array to here such that transitioning of scroll loop is seamlees, comment for restart */}
            </div>
        </div>
    );
};

export default AdvertisementSlider;